import { LanguageEnum } from '../../../utils/language.util';

export const DEFAULT_LANGUAGE = LanguageEnum.lat;
export const LANGUAGE_HEADER = 'language';

export function getLanguage(): LanguageEnum {
  return localStorage.getItem('language') as LanguageEnum || DEFAULT_LANGUAGE;
}

export function setLanguage(lang: string): void {
  localStorage.setItem('language', lang);
}
